import {del, get, post, put} from './capitalAxios';
import {buildQueryParams} from '../utils';

const BASE = '/api/v1/milestone';

export const findAllMilestones = ({from, to, searchText} = {}) =>
    get(BASE + buildQueryParams([
        {key: 'from', value: from},
        {key: 'to', value: to},
        {key: 'searchText', value: searchText || null},
    ]));

export const createMilestone = (body) => post(BASE, body);
export const updateMilestone = (id, body) => put(`${BASE}/${id}`, body);
export const deleteMilestone = (id) => del(`${BASE}/${id}`);